// extracted by mini-css-extract-plugin
export default {"button":"TransferFileButton_button__Cssqz","disabledButton":"TransferFileButton_disabledButton__gxawq"};